<template>
  <card col-md-12>
    <h4 slot="header" class="card-title">Transferir Manifestação</h4>
    <form>
      <div class="row">
          <div class="col-md-12" v-if="row">
            <div class="card" style="margin-top:20px;" >
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12" style="padding-top: 15px;">
                          <p class="p-line">Numero da Manifestação: {{row.numero_manifesto}} </p>
                          <p class="p-line">Tipo: {{row.tipo_assunto}}</p> 
                          <p class="p-line" v-if="row.cidadao_login">
                            Cidadão: {{row.cidadao_login}} 
                          </p>
                          <p class="p-line">
                            Secretaria: {{row.secretaria}}
                          </p>
                          <p class="p-line">
                            Assunto: {{row.assunto}}
                          </p>
                          <p class="p-line">
                            Descrição: {{row.conteudo}}
                          </p>
                          <p class="p-line" v-if="row.bairro">
                            Bairro: {{row.bairro}}
                          </p>
                          <p class="p-line">
                            <i v-if="row.rua">{{row.rua}},</i> <i v-if="row.numero">{{row.numero}} -</i> <i v-if="row.complemento">{{row.complemento}}</i>
                          </p>
                          
                          <p class="p-line">
                            {{row.abertura}}
                          </p>
                        </div>
                    </div>
                    
                </div>  
            </div> 
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" v-if="msgAlterada" >
            <div
              class="card"
              style="background-color: rgb(50 170 159) !important;color: #fff !important;margin-bottom: 20px !important;"
              v-if="msg==1"
            >
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">{{msgAlterada}}</div>
                </div>
              </div>
            </div>
            <div
              class="card"
              style="background-color: rgb(170 72 50) !important;color: #fff !important;margin-bottom: 20px !important;"
              v-if="msg==0"
            >
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">{{msgAlterada}}</div>
                </div>
              </div>
            </div>
            <div
              class="card"
              style="background-color: rgb(191 187 54) !important;color: #fff !important;margin-bottom: 20px !important;"
              v-if="msg==2"
            >
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">{{msgAlterada}}</div>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-5">
          <div class="form-group">
            <label for="departamento">Nova Unidade Organizacional:</label>
            <select class="form-control"  v-model="manifesto.secretaria">
                <option v-for="a in secretariasexibir" :key="a.id" :value="a.id">{{a.secretaria}}</option>
            </select>
          </div>
        </div>
      </div>  
      <div class="row">
        <div class="text-center" style="margin-left:15px">
          <button type="submit" class="btn btn-primary btn-fill float-left" @click.prevent="transferirform">  
            Transferir Departamento
          </button>
          <button class="btn btn-danger" @click="retornar()"  style="margin-left: 8px;">Retonar</button>
        </div>
      </div>
      <div class="clearfix"></div>
    </form>
  </card>
</template>
<script>
  import Card from 'src/components/Cards/Card.vue'
  import 'src/controller/sistema/manifestacaoController.js'
  import 'src/controller/sistema/assuntoSecretariaController.js'

  export default {
    components: {
      Card
    },
    props: {
      row: {
          require: true
      }
    },
    data () {
      return {
        secretariasexibir:null,
        manifesto:{
          secretaria : null
        },
        msgAlterada: null,
        msg: null,
      }
    },
    methods: {
      retornar(){
         this.$router.push('/sistema/Manifestacao');
      },
      async secretarias(){
         try {
           
            let data = await this.$secretaria(); 
            this.secretariasexibir = data.data;
            
            //console.log(data);
         } catch (e) {
             
         }
      },
      async secretariaTranfosmeNameId(row){
          try {
              let data = await this.$secretaria(); 
              let sec = data.data;

              sec.forEach(element => {
                 if(row.secretaria == element.secretaria){
                    this.manifesto.secretaria = element.id;
                 }
              });
               
          } catch (e) {
             //console.log(e);
          }
      },
      async transferirform(){
         try {
           var r = confirm("Deseja transferir a Manifestação para outro Departamento?");
           if (r == true) {
              let me = await this.$me();
              let data = await this.$movimentarDepartamento(this.row.uuid,this.manifesto.secretaria,me.id);
              if (data.status == 200) {
                this.msgAlterada = "A Manifestação foi transferida com Sucesso!";
                this.msg = 1;
                setTimeout( () => this.$router.push({ path: '/sistema/Manifestacao'}), 100);
                //return false;
              }else{
                this.msgAlterada = "Ops! ocorreu um erro inespicavel, tente novamente. ";
                this.msg = 0;
                return false;
              }
              /*alert('Manifestação transferida com sucesso!');
              this.$router.push('/sistema/Manifestacao');*/
              
           }else{
             console.log(e);
           }
         } catch (e) {
           
         }
      }
      
    },
    beforeMount() {
      if(this.row == null){
          this.$router.push('/sistema/Manifestacao');
      }else{
        try {
          this.secretariaTranfosmeNameId(this.row);
          this.secretarias();
        } catch (e) {
        }
        
      }  
   }
  }
  

</script>
<style>

</style>
